import React from 'react';
import { Card, CardContent } from '../../../../components/ui/card';
import { Skeleton } from '../../../../components/ui/skeleton';
import { MonitoringStats } from '../../types/site-monitor';
import { Globe, CheckCircle, AlertTriangle, Gauge } from 'lucide-react';

interface MonitoringStatsCardsProps {
  stats: MonitoringStats | null;
  loading: boolean;
}

const MonitoringStatsCards: React.FC<MonitoringStatsCardsProps> = ({ stats, loading }) => {
  if (loading || !stats) {
    return (
      <>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex-1 min-w-[200px]">
            <Card>
              <CardContent className="p-6">
                <div className="flex items-center gap-4">
                  <Skeleton className="h-12 w-12 rounded-lg" />
                  <div className="space-y-2 flex-1">
                    <Skeleton className="h-3 w-24" />
                    <Skeleton className="h-7 w-16" />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        ))}
      </>
    );
  }

  const cards = [
    {
      title: 'Total Monitorados',
      value: stats.total,
      Icon: Globe,
      iconBg: 'bg-primary/10',
      iconColor: 'text-primary',
    },
    {
      title: 'Online',
      value: stats.up,
      Icon: CheckCircle,
      iconBg: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
    },
    {
      title: 'Offline',
      value: stats.down,
      Icon: AlertTriangle,
      iconBg: 'bg-red-50',
      iconColor: 'text-red-600',
    },
    {
      title: 'TTFB Medio',
      value: `${stats.avgTtfbMs}ms`,
      Icon: Gauge,
      iconBg: 'bg-sky-50',
      iconColor: 'text-sky-600',
    },
  ];

  return (
    <>
      {cards.map((card, i) => (
        <div key={i} className="flex-1 min-w-[200px]">
          <Card className="transition-shadow hover:shadow-md">
            <CardContent className="p-6">
              <div className="flex items-center gap-4">
                <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${card.iconBg}`}>
                  <card.Icon className={`h-6 w-6 ${card.iconColor}`} />
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
                    {card.title}
                  </p>
                  <p className="mt-[0.25rem] text-2xl font-bold tracking-tight">{card.value}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      ))}
    </>
  );
};

export default MonitoringStatsCards;
